import { render, staticRenderFns } from "./lookupTypeFilterElement.vue?vue&type=template&id=2740163c&scoped=true"
import script from "./lookupTypeFilterElement.vue?vue&type=script&lang=js"
export * from "./lookupTypeFilterElement.vue?vue&type=script&lang=js"
import style0 from "./lookupTypeFilterElement.vue?vue&type=style&index=0&id=2740163c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740163c",
  null
  
)

export default component.exports